// ----------------------------------------------------------------------------
// Section: Featured Tiles
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper, { A11y, Keyboard, Pagination } from 'swiper';

// Style includes
import 'swiper/css';
import 'swiper/css/a11y';
import 'swiper/css/pagination';
import 'swiper/css/keyboard';
import 'swiper/css/pagination';
import './_holiday-banner.scss';

// -------------------------------------
// Variables
// -------------------------------------

// Selectors
const FEATURED_TILES_SLIDER_SELECTOR = '.carousel--holiday-banner__container';
const CAROUSEL_SELECTOR              = '.carousel--holiday-banner';

// -------------------------------------
// Helpers
// -------------------------------------

const initFeaturedTiles = (slider) => {
    const carousel   = slider.querySelector(CAROUSEL_SELECTOR);

    const swiper = new Swiper(carousel, {
        modules: [A11y, Keyboard, Pagination],
        slidesPerView: 1.1,
        spaceBetween: 5,
        // centerInsufficientSlides: true,
        observer: true,
        observeParents: true,
        a11y: false,
        grabCursor: true,
        draggable: true,
        simulateTouch: true, // Ensure this is true for touch interactions.

        breakpoints: {
            680: {
                slidesPerView: 2.1,
                spaceBetween: 5,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 0,
            },
        },

        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        }
    });

    swiper.slides.forEach(function(slide, index) {
        const slideLink = slide.querySelector('a');

        slideLink.addEventListener('focus', function(e) {
            swiper.slideTo(index);
        })
    });
}

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    const featuredTilesSliders = document.querySelectorAll(FEATURED_TILES_SLIDER_SELECTOR);


    featuredTilesSliders.forEach((featuredTilesSlider) => {

        initFeaturedTiles(featuredTilesSlider);
    });
});
